<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbarFive class="home_one" />
  <PageBanner pageTitle="Portfolio Details" mainTitle="Portfolio Details" />
  <PortfolioDetails />
  <HowItWorks />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbarFive from "../components/Layouts/ResponsiveNavbarFive.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import PortfolioDetails from "../components/PortfolioDetails/PortfolioDetails.vue";
import HowItWorks from "../components/PortfolioDetails/HowItWorks.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "PortfolioDetailsPage",
  components: {
    NavbarFive,
    ResponsiveNavbarFive,
    PageBanner,
    PortfolioDetails,
    HowItWorks,
    DownloadTheApp,
    MainFooter,
  },
});
</script>